<template>
  <div class="page-header">
    <!-- logo区域 -->
    <div class="logo-content">
      <!-- <div class="company-title"><strong>上海金山商业发展（集团）有限公司</strong></div>
      <div class="company-title">上海市金山区供销合作社</div> -->
      <img src="@/assets/logo.png"
           style="width:500px;"
           alt="">
    </div>

    <!-- 菜单栏 -->
    <a-affix>
      <div class="nav-content">
        <!-- 一级菜单 -->
        <ul class="menu">
          <a-spin :spinning="!catalogs.length">
            <a-icon slot="indicator"
                    type="loading"
                    style="font-size: 24px"
                    spin />
          </a-spin>
          <li class="menu-item"
              :class="{'menu-item-selected':item.selected,'no-pointer':item.type==='D'}"
              v-for="item in catalogs"
              :key="item.catid"
              @mouseover="hoverMenu(item,$event)"
              @click="navToRoute(item)"
              @mouseout="()=>{menuHovered = false}">
            <span>
              {{item.title}}
            </span>
          </li>
          <!-- <li style="float: right;margin-bottom: 4px;"
              class="menu-item">
            <router-link to='/qykx/tzgg/doc/91189625'>
              <a-button type="primary">
                招聘信息
              </a-button>
            </router-link>
          </li> -->
        </ul>

        <!-- 二级菜单 -->
        <ul class="sub-menu"
            ref='subMenu'
            @mouseover="()=>{subMenuHovered=true}"
            @mouseout="()=>{subMenuHovered=false}"
            v-show="selectedMenuItem.children.length !== 0 && (menuHovered || subMenuHovered)">
          <span><em></em></span>

          <li class="sub-menu-item"
              :class="{'sub-menu-item-selected':item.selected}"
              ref="subMenuItems"
              v-for="item in selectedMenuItem.children"
              :key="item.catid"
              @click="navToRoute(item)">
            {{item.title}}
          </li>
        </ul>
      </div>
    </a-affix>

  </div>
</template>

<script >

export default {
  name: 'PageHeader',
  data () {
    return {
      init: true,
      menuHovered: false,
      subMenuHovered: false,
      selectedMenuItem: {
        catid: 1,
        route: 'index',
        type: 'C',
        key: '0-1',
        title: '首页',
        value: 1,
        parentId: 0,
        children: []
      },
      selectedCatid: -1
    }
  },

  computed: {
    catalogs () {
      return JSON.parse(JSON.stringify(this.$store.state.catalogs))
    }
  },

  watch: {
    // 监听菜单变化，仅在初次监听到变化时，修正当前指向（初次载入时，根据url设置当前指向菜单）
    catalogs () {
      if (this.init) {
        // console.log('init proc')
        this.routeRefresh()
        this.init = false
      }
    },
    // 监听路由
    $route () {
      this.routeRefresh()
    }

  },

  methods: {

    // 鼠标悬停一级目录时，展开二级目录
    hoverMenu (item, e) {
      this.menuHovered = true
      this.selectedMenuItem = item
      if (item.children.length !== 0) {
        // 计算当前指向元素的底部位置，用于调整二级菜单水平位置(left属性)
        let el = e.target
        let left = 0

        while (el.offsetParent) {
          left += el.offsetLeft
          el = el.offsetParent
        }

        // 二级菜单的过度效果(根据元素内容计算尺寸)
        const subItemQty = item.children && item.children.length
        let maxSubItemLen = item.children && item.children[0].title.length
        item.children && item.children.forEach(citem => {
          maxSubItemLen = citem.title.length > maxSubItemLen ? citem.title.length : maxSubItemLen
        })

        this.$refs.subMenu.style.left = left + 20 + 'px'
        this.$refs.subMenu.style.width = maxSubItemLen * 24 + 10 + 'px'
        this.$refs.subMenu.style.height = subItemQty * 28 + 24 + 'px'
        this.$refs.subMenu.style.color = 'transparent'
        const that = this
        setTimeout(() => {
          that.$refs.subMenu.style.color = '#222'
        }, 100)
        setTimeout(() => {
          that.$refs.subMenu.style.left = left + 'px'
        }, 50)
      }
    },

    // 路由跳转
    navToRoute (menuItem) {
      // D类型表示纯目录，点击不进行跳转
      console.log(menuItem.type)
      if (menuItem.type !== 'D') {
        this.$router.push('/' + menuItem.route)
        this.menuHovered = false
        this.subMenuHovered = false
      }
    },

    // 路由变化时刷新选中样式
    routeRefresh () {
      // 根据路由重置菜单选中标识
      this.reSelectCatalogs(this.catalogs)
      // 选中状态已被修改，但是没有立即生效，需要调用此方法来强制重新渲染
      this.$forceUpdate()

      // 同步到vuex中
      this.$store.commit('setCatalogs', this.catalogs)
      this.$store.commit('setSelectedCatid', this.selectedCatid)
      // console.log('同步catlogs', this.catalogs, this.selectedCatid)
    },

    // 递归遍历菜单
    reSelectCatalogs (catalogs) {
      const currentRoutePath = this.$route.path
      const currentNode = catalogs
      currentNode.forEach(item => {
        // 判断当前路径下的菜单是否被选中
        if (currentRoutePath.match('/' + item.route + '.*')) {
          item.selected = true
          this.selectedCatid = item.catid
        } else {
          item.selected = false
        }
        item.children && this.reSelectCatalogs(item.children)
      })
      return catalogs
    }
  }

}

</script>
<style scoped>
li {
  list-style: none;
}

* {
  caret-color: rgba(0, 0, 0, 0);
}

.page-header {
  width: 100%;
  background-color: #13aa52;
  /* display: flex; */
}

.logo-content {
  padding: 10px 0;
  width: 80%;
  min-width: 1000px;
  margin: auto;
}

.company-title {
  padding: 6px 12px;
  font-size: 36px;
  color: #fff;
  font-weight: 600;
  line-height: 36px;
  font-family: "FangSong";
}

.nav-content {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.01), 0 10px 30px rgba(0, 0, 0, 0.08);
  z-index: 1000000;
  position: relative;
}

.menu {
  position: relative;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  background-color: #fff;
  width: 80%;
  min-width: 1000px;
  margin: auto;
  font-size: 17px;
  color: #42494f;
  align-items: center;
  justify-content: left;
  padding: 0 40px;
}

.page-header >>> .ant-affix {
  z-index: 999999;
}

.menu-item {
  display: inline-block;
  padding: 10px 5px;
  cursor: pointer;
  transition: all 0.2s;
}

.no-pointer {
  cursor: default;
}

.menu-item span {
  display: inline-block;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  margin-bottom: 6px;
}

.menu-item span:hover {
  /* border-bottom: 3px solid; */
  color: #066f30;
  /* font-weight: 600; */
}
.menu-item-selected span {
  color: #fff;
  background-color: #13aa52;
  transition: all 0.2s;
  border-radius: 4px;
}

.menu-item-selected span:hover {
  color: #fff;
  background-color: #13aa52;
  transition: all 0.5s;
}
.sub-menu {
  position: absolute;
  display: inline-block;
  background-color: #fff;
  padding: 12px 0px;
  font-size: 15px;
  color: #42494f;
  border: 1px solid #eceeef;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.01), 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: left 0.2s linear, width 0.2s linear, height 0.2s linear;
  z-index: 1000000;
  top: 50px;
}

.sub-menu span {
  display: block;
  width: 0;
  height: 0;
  border-width: 0 10px 10px;
  border-style: solid;
  /* border-color: transparent transparent #13aa52; */
  border-color: transparent transparent #eceeef;
  position: absolute;
  top: -10px;
  left: 40px; /* 三角形居中显示 */
  margin-left: -10px; /* 三角形居中显示 */
}

.sub-menu span em {
  display: block;
  width: 0;
  height: 0;
  border-width: 0 10px 10px;
  border-style: solid;
  border-color: transparent transparent #fff;
  position: absolute;
  top: 1px;
  left: -10px;
}

.sub-menu-item {
  box-sizing: border-box;
  padding: 3px 24px 3px 16px;
  border-left: 4px solid transparent;
  cursor: pointer;
  /* transition: opacity 0.1s linear; */
  overflow-wrap: unset;
}
.sub-menu-item:hover {
  border-left: 4px solid #10aa52;
  background-color: #fafbfc;
  color: #000;
  transition: all 0.2s;
}

.sub-menu-item-selected {
  border-left: 4px solid #6dd497;
  background-color: #6dd497;
  color: #222;
  transition: all 0.2s;
}

.sub-menu-item-selected:hover {
  border-left: 4px solid #6dd497;
  background-color: #6dd497;
  color: #222;
  transition: all 0.2s;
}
</style>
